import { default as Image } from '../images/imageUrls';
import { ImageKey } from '../images/ImageKey';
import { ColorThemeOption } from './ColorLibrary';
import { MessageKey } from './MessageKey';
import { MessageTypes } from './MessageTypes';
import { Data } from 'signup-constants/signupData/Data';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
let MESSAGE;
const getMessages = () => {
  if (typeof MESSAGE === 'undefined') {
    const BLONDE_SHELLEY = MessageTypes.blobProfile({
      imageUrl: [Image.blondeShelley1x, Image.blondeShelley2x, Image.blondeShelley3x],
      colorThemeOption: ColorThemeOption.YellowLight,
      blobBleed: true,
      imageHeight: 360,
      blobBleedConfig: {
        yOffset: -10
      }
    });
    const MARGAUX_IMAGE = MessageTypes.messageBlobCaption({
      imageUrl: [Image.crmCentralPlace1x, Image.crmCentralPlace2x, Image.crmCentralPlace3x],
      imageHeight: 330,
      colorThemeOption: ColorThemeOption.OrangeLight,
      captionImageHeight: 34,
      blobBleedConfig: {
        xOffset: -1.5
      },
      blobBleed: false
    });
    const HUB_INTEREST_MARKETING = MessageTypes.illustratedList({
      illustrationName: 'marketing-free',
      isHTMLMessage: true,
      height: '150px'
    });
    const HUB_INTEREST_SALES = MessageTypes.illustratedList({
      illustrationName: 'sales-free',
      isHTMLMessage: true,
      height: '150px'
    });
    const HUB_INTEREST_CUSTOMER_SERVICE = MessageTypes.illustratedList({
      illustrationName: 'service-free',
      isHTMLMessage: true,
      height: '150px'
    });
    const HUB_INTEREST_CMS = MessageTypes.illustratedList({
      illustrationName: 'website-platform-laptop',
      isHTMLMessage: true,
      height: '150px'
    });
    const HUB_INTEREST_LANDING_PAGE = MessageTypes.illustratedList({
      illustrationName: 'mobile-onboarding-account-ready',
      height: '150px'
    });
    const HUB_INTEREST_HIGHLIGHT_CAPTION = MessageTypes.highlightCaption(Object.assign({}, HUB_INTEREST_LANDING_PAGE, {
      landingPageComponent: () => null,
      dataKey: Data.HubInterest,
      highlightMessageKeys: {
        [HubInterestOption.Sales]: MessageKey.HubInterestSales,
        [HubInterestOption.Marketing]: MessageKey.HubInterestMarketing,
        [HubInterestOption.CustomerService]: MessageKey.HubInterestCustomerService,
        [HubInterestOption.CMS]: MessageKey.HubInterestCms
      }
    }));
    MESSAGE = {
      [MessageKey.CheckYourEmail]: MessageTypes.contentCheckYourEmail(),
      [MessageKey.CheckYourEmailDefaultAnimation]: MessageTypes.animation({
        imageUrl: Image.emailAnimation,
        topMargin: '-70'
      }),
      [MessageKey.CheckYourEmailAlternativeIllustration]: MessageTypes.illustration({
        illustrationName: 'email-confirmation',
        colorThemeOption: ColorThemeOption.YellowLight,
        topMargin: '-20'
      }),
      [MessageKey.CrmCentralPlace]: MARGAUX_IMAGE,
      [MessageKey.HubInterestLandingPage]: HUB_INTEREST_HIGHLIGHT_CAPTION,
      [MessageKey.HubInterestSales]: HUB_INTEREST_SALES,
      [MessageKey.HubInterestMarketing]: HUB_INTEREST_MARKETING,
      [MessageKey.HubInterestCustomerService]: HUB_INTEREST_CUSTOMER_SERVICE,
      [MessageKey.HubInterestCms]: HUB_INTEREST_CMS,
      [MessageKey.WordpressConnect]: MessageTypes.imageMessage({
        imageKey: ImageKey.Wordpress
      }),
      [MessageKey.ShopifyEmbeddedConnect]: MessageTypes.imageMessage({
        imageKey: ImageKey.ShopifyEmbedded
      }),
      [MessageKey.BlondeShelley]: BLONDE_SHELLEY,
      [MessageKey.CampaignAssistant]: MessageTypes.campaignAssistant(),
      [MessageKey.BlogGenerator]: MessageTypes.blogGenerator(),
      [MessageKey.LandingPageCreator]: MessageTypes.landingPageCreator(),
      [MessageKey.UseCase]: MessageTypes.contentUseCase(),
      [MessageKey.CompanyDomain]: MessageTypes.contentCompanyDomain(),
      [MessageKey.InvoiceGenerator]: MessageTypes.invoiceGenerator()
    };
  }
  return MESSAGE;
};
export const getMessage = messageKey => {
  return getMessages()[messageKey];
};
export const setTestMessage = (messageKey, value) => {
  const messages = getMessages();
  messages[messageKey] = value;
  return messages;
};
export const DEFAULT_MESSAGING = {};